import { useState } from "react"
import useMyInvites from "../hooks/useMyInvites"
import { Text } from "../../../modules/Dashboard"
import { Flex } from "../../../styles/CommonStyles"
import { p2e } from "../../../core/utils/common"
import { ClipLoader } from "react-spinners"
import { Input } from "../../../styles/newStyles/Register.styled"


const CreateInviteCodeForm = () => {
	const { createInviteCode, isCreating } = useMyInvites()

	const [maxUse, setMaxUse] = useState('')

	const [actorShare, setActorShare] = useState(100)
	const [objectShare, setObjectShare] = useState(0)


	const handleForm = (e) => {
		e.preventDefault()

		if (isCreating || maxUse < 1) {
			return false
		}

		try {
			createInviteCode({ maxUse: parseInt(maxUse), actorShare, objectShare })
		} catch (e) { }
	}


	return (
		<div style={{ width: '100%' }} >
			<form onSubmit={handleForm}>
				<p className={'text-start'}>
					<Text tid={'specify-invite-code-desc'} className="text-lg" />
				</p>
				<div className={'my-5 space-y-3'}>
					<label className={'block'}>
						<Text tid={'usage-limit'} className="text-mainColor" />
					</label>
					<Input
						className="!h-[62px] !bg-[#0F172B80]"
						placeholder="# 10"
						value={maxUse}
						onChange={(e) => {
							setMaxUse(p2e(e?.target?.value))
						}}
					/>
					<Text tid="invite-input-help" className="text-mainColor" />
				</div>
				<Flex justify={'center'}>
					<button type={'submit'} className="w-full py-4 rounded-lg bg-gradient-to-r from-[#FC6432] to-[#A855F7]">
						{
							isCreating ? (<ClipLoader color='#ffffff' size={20} />) : (<Text tid={'generate-code'} className="!text-white" />)
						}
					</button>
				</Flex>
			</form>
		</div>
	)
}

export default CreateInviteCodeForm
